import { createAction } from 'redux-actions';
import { ModalType } from '../../Modals/redux/types';
import { pushModal } from '../../Modals/redux/basicActions';
export var reduxKey = '@@DeviationGroupList';
export var showDeviationGroupListPopup = function (params) { return pushModal(ModalType.DEVIATION_GROUP_LIST, { params: params }); };
export var getStreamId = function (deviationId) {
    return "featuredInGroups-".concat(deviationId);
};
export var initializeStreamAndFetchFirst = createAction("".concat(reduxKey, "/INITIALIZE"), function (deviationId) { return ({ deviationId: deviationId }); });
export var fetchNext = createAction("".concat(reduxKey, "/FETCH_NEXT"), function (streamId) { return ({ streamId: streamId }); });
//# sourceMappingURL=actionCreators.js.map